import { render } from "./Header.vue?vue&type=template&id=267b6bf2&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=267b6bf2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-267b6bf2"

export default script